/* tslint:disable */
import {
  Institutions
} from '../index';

declare var Object: any;
export interface SectorInterface {
  "name": string;
  "description"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions[];
}

export class Sector implements SectorInterface {
  "name": string;
  "description": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions[];
  constructor(data?: SectorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sector`.
   */
  public static getModelName() {
    return "Sector";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sector for dynamic purposes.
  **/
  public static factory(data: SectorInterface): Sector{
    return new Sector(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sector',
      plural: 'Sectors',
      path: 'Sectors',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions[]',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Sector.ts